import { render, staticRenderFns } from "./FileIconColumnTemplateComponent.vue?vue&type=template&id=95115b6c&scoped=true"
import script from "./FileIconColumnTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./FileIconColumnTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./FileIconColumnTemplateComponent.vue?vue&type=style&index=0&id=95115b6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95115b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95115b6c')) {
      api.createRecord('95115b6c', component.options)
    } else {
      api.reload('95115b6c', component.options)
    }
    module.hot.accept("./FileIconColumnTemplateComponent.vue?vue&type=template&id=95115b6c&scoped=true", function () {
      api.rerender('95115b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/FileIconColumnTemplateComponent.vue"
export default component.exports